import _trimEnd from "lodash/trimEnd";

export function normalizeBaseUrl(baseUrl: string) {
  return _trimEnd(baseUrl, "/");
}
